package com.macrofocus.nastac.components

import com.macrofocus.nastac.DataLoader
import com.macrofocus.nastac.book.chapters
import emotion.react.css
import mui.icons.material.Download
import mui.material.*
import mui.material.Size
import mui.material.styles.TypographyVariant
import mui.system.Box
import mui.system.responsive
import mui.system.sx
import react.*
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.span
import web.cssom.*
import web.cssom.LineStyle.Companion.solid

external interface ReplicationProps : Props {
    var dataLoader: DataLoader
}

val Replication = FC<ReplicationProps> { props ->
    val imageNames = listOf(
        "IMG_2325.jpeg",
    )

    val imagesUrls = imageNames.map { s -> url(s) }

    val (index, setIndex) = useState(0)

    div {
        css {
            display = Display.flex
            justifyContent = JustifyContent.center
            /* Let it take full height */
            height = 100.vh

            /* Enable scrolling */
            overflowY = Auto.auto
        }

        Box {
            component = div
            sx {
                position = Position.absolute
                top = 0.px
                left = 0.px
                width = 100.pct
                height = 100.pct
                backgroundImage = imagesUrls[index].unsafeCast<BackgroundImage?>()
                backgroundSize = BackgroundSize.cover
                backgroundPosition = "center".unsafeCast<BackgroundPosition>()
                transition = "background-image 3s ease-in-out".unsafeCast<Transition>()
                opacity = number(0.3)
            }
        }


        Box {
            sx {
                position = Position.relative
                // So that there is no overlap with the Sidebar
                marginLeft = 330.px
                width = "calc(100vw - 330px)".unsafeCast<Width>()

                height = 100.vh
                overflow = Overflow.hidden
                display = Display.flex
                justifyContent = JustifyContent.center
                alignItems = AlignItems.center
                paddingLeft = 16.px
                paddingTop = 8.px
                paddingRight = 48.px
                paddingBottom = 16.px

                /* Use min-height instead of fixed height to allow shrinking */
                minHeight = 100.pct
                display = Display.flex
                flexDirection = FlexDirection.column
                justifyContent = JustifyContent.start
                overflowY = Auto.auto
            }

            // Foreground Card
            Card {
                sx {
                    position = Position.relative
                    maxWidth = 900.px
                    width = 100.pct
                    backgroundColor = rgb(0, 0, 0, 0.7)
                    color = NamedColor.white
                    //                zIndex = 1
                    padding = 24.px
                    borderRadius = 12.px
                    overflowY = Auto.auto

                    background = rgb(255, 255, 255, 0.3)
                    backdropFilter = blur(10.px)
                    border = Border(1.px, solid, rgb(255, 255, 255, 0.4))
                    borderRadius = 16.px
                    boxShadow = BoxShadow(0.px, 4.px, 30.px, rgb(0, 0, 0, 0.2))
                    backgroundImage = linearGradient(
                        angle = 135.deg,
                        rgb(255, 255, 255, 0.4),
                        rgb(255, 255, 255, 0.1)
                    )
                    color = NamedColor.black
                    fontWeight = FontWeight.normal
                    padding = Padding(4.px, 8.px)
                    hover {
//                    background = props.tintColor?.let { Color(it).alpha(0.3) } ?: rgb(255, 255, 255, 0.3)
                        background = rgb(255, 255, 255, 0.3)
                        boxShadow = BoxShadow(0.px, 6.px, 40.px, rgb(0, 0, 0, 0.15))
                    }
                    transition = Transition(
                        property = TransitionProperty.all,
                        duration = 0.3.s,
                        timingFunction = TransitionTimingFunction.easeInOut
                    )
                }

                CardContent {
                    // Title and Subtitle
                    //        Typography {
                    //            variant = TypographyVariant.h3
                    //            gutterBottom = true
                    //            align = TypographyAlign.center
                    //            +"Nationalism and the Transformation of the State"
                    //        }
                    //        Typography {
                    //            variant = TypographyVariant.subtitle1
                    //            gutterBottom = true
                    //            align = TypographyAlign.center
                    //            sx { marginBottom = 24.px }
                    //            +"Border Change and Political Violence in the Modern World"
                    //        }

                    // Section: Replication Materials
                    Typography {
                        variant = TypographyVariant.h5
                        gutterBottom = true
                        +"Replication Materials for the book "
                        +"Nationalism and the Transformation of the State: "
                        +"Border Change and Political Violence in the Modern World"
                    }
                    Typography {
                        variant = TypographyVariant.body1
                        paragraph = true
                        sx { marginBottom = 24.px }
                        +"The replication materials for each chapter are available in both "
                        +"ZIP"
                        +" and "
                        +"tar.gz"
                        +" formats. "
                        +"Please cite the following when using these materials:"
                    }

                    // Citation Block
                    Paper {
                        elevation = 2
                        sx {
                            padding = 16.px
                            marginBottom = 32.px
                            //                backgroundColor = mui.material.colors.grey[50]
                            //                border = "1px solid ${mui.material.colors.grey[300]}"
                        }
                        Typography {
                            variant = TypographyVariant.body2
                            component = div
                            sx {
                                fontStyle = FontStyle.normal
                                lineHeight = 1.6.em
                            }
                            +"Cederman, Lars-Erik, Luc Girardin, Carl Müller-Crepon, and Yannick Pengl. 2025. "
                            Typography {
                                variant = TypographyVariant.body2
                                component = span
                                sx {
                                    fontStyle = FontStyle.italic
                                    lineHeight = 1.6.em
                                }
                                +"Nationalism and the Transformation of the State: Border Change and Political Violence in the Modern World."
                            }
                            +" Cambridge University Press."
                        }
                    }

                    // Download List
                    List {
                        disablePadding = true

                        chapters.forEach { chapter ->
                            val chapterName = if(chapter.number != null) {
                                "Chapter ${chapter.number} ${chapter.title}"
                            } else {
                                chapter.title
                            }

                            val s = chapter.sources
//                            val sources = if(s.isNotEmpty()) {
//                            } else {
//                                null
//                            }

                            ListItem {
                                divider = true
                                ListItemText {
                                    primary = ReactNode(chapterName)
                                    if(s.isNotEmpty()) {
                                        val b: ReactNode = Box.create {
                                            if (s.size > 1) {
                                                +"Main datasets used: "
                                            } else {
                                                +"Main dataset used: "
                                            }
                                            s.forEachIndexed { index, item ->
                                                +item.create()
                                                if (index < s.lastIndex) {
                                                    +", "
                                                }
                                            }
                                        }
//                                        secondary = ReactNode("Available in ZIP and tar.gz")
                                        secondary = b
                                    }
                                }
                                ListItemSecondaryAction {
                                    Stack {
                                        direction = responsive(StackDirection.row)
                                        spacing = responsive(1)

// ZIP Button with Size
                                        Button {
                                            variant = ButtonVariant.outlined
                                            color = ButtonColor.primary
                                            size = Size.small
                                            startIcon = Download.create {}
                                            href = "/replication/${chapter.filename}.zip"
                                            asDynamic().download = "${chapter.filename}.zip"
                                            onClick = { /* optional analytics */ }

                                            Stack {
                                                direction = responsive(StackDirection.column)
                                                spacing = responsive(0)
                                                asDynamic().alignItems = ListItemAlignItems.center

                                                + "ZIP"
                                                Typography {
                                                    variant = TypographyVariant.caption
                                                    sx {
                                                        fontSize = 10.px
                                                        lineHeight = 1.2.em
                                                        opacity = number(0.7)
                                                    }
                                                    + (chapter.fileSize ?: "—")
                                                }
                                            }
                                        }

                                        // tar.gz Button with Size
                                        Button {
                                            variant = ButtonVariant.outlined
                                            color = ButtonColor.secondary
                                            size = Size.small
                                            startIcon = Download.create {}
                                            href = "/replication/${chapter.filename}.tar.gz"
                                            asDynamic().download = "${chapter.filename}.tar.gz"

                                            Stack {
                                                direction = responsive(StackDirection.column)
                                                spacing = responsive(0)
                                                asDynamic().alignItems = ListItemAlignItems.center

                                                + "tar.gz"
                                                Typography {
                                                    variant = TypographyVariant.caption
                                                    sx {
                                                        fontSize = 10.px
                                                        lineHeight = 1.2.em
                                                        opacity = number(0.7)
                                                    }
                                                    + (chapter.fileSize ?: "—")
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }

                    // Footer note
                    Typography {
                        variant = TypographyVariant.caption
                        asDynamic().display = Display.block
                        align = TypographyAlign.center
                        sx {
                            marginTop = 40.px;
                            //                color = mui.material.colors.grey[600]
                        }
                        +"All materials are provided for academic research purposes. Proper citation is required."
                    }
                }
            }
        }
    }
}